// @core/api/endpoints/tag/tag_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TagEntityRequest,
  TagEntityResponse,
} from '../../../types/tag';

const BASE_PATH = '/tag';

/**
 * Tag an entity
 * Assigns a tag to an entity. The entity is identified by its Entity fields. Idempotent: re-tagging an already tagged entity is a no-op.
 */
export async function TagEntity(
  tag_id: string,
  data: TagEntityRequest,
  options?: RequestOptions
): Promise<TagEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tags/:tag_id/entities`;
  requestPath = requestPath.replace(':tag_id', encodeURIComponent(tag_id));
  const requestOptions = options;
  return client.post<TagEntityResponse>(requestPath, data, requestOptions);
}
